<template>
  <div>
    <SupplierList />
  </div>
</template>
<script>
import SupplierList from "../supplier/SupplierList.vue";
export default {
  components: {
    SupplierList,
  },
};
</script>
